import axios from "axios";
import { API_BE4FE_URL } from "../config";
import IndexDocument from "../interfaces/documentIndexLabel";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";
import {
    hideLockOverlay,
    showLockOverlay,
    showNotificationOverflow,
} from "./ui";

export const GET_INDEX_DOCUMENT_START = "GET_INDEX_DOCUMENT_START";
export const GET_INDEX_DOCUMENT_SUCCESS = "GET_INDEX_DOCUMENT_SUCCESS";
export const GET_INDEX_DOCUMENT_ERROR = "GET_INDEX_DOCUMENT_ERROR";
export const GET_INDEX_DOCUMENT_NOT_FOUND = "GET_INDEX_DOCUMENT_NOT_FOUND";
export const UPLOAD_INDEX_DOCUMENT_START = "UPLOAD_INDEX_DOCUMENT_START";
export const UPLOAD_INDEX_DOCUMENT_SUCCESS = "UPLOAD_INDEX_DOCUMENT_SUCCESS";
export const UPLOAD_INDEX_DOCUMENT_ERROR = "UPLOAD_INDEX_DOCUMENT_ERROR";
// Related to labels reducer
export const INIT_LABELS_FROM_DOCUMENT = "INIT_LABELS_FROM_DOCUMENT";

export const getIndexDocument = () => {
    return (dispatch: any, getState: () => RootState) => {
        dispatch(showLockOverlay(true, "Aggiornamento informazioni..."));
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: GET_INDEX_DOCUMENT_START });
            axios
                .get(`${API_BE4FE_URL}/index-document?itemId=${itemId}`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch(hideLockOverlay());
                    dispatch({
                        type: GET_INDEX_DOCUMENT_SUCCESS,
                        payload: result.data,
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch(hideLockOverlay());
                    if (e.response && e.response.status === 404) {
                        dispatch({ type: GET_INDEX_DOCUMENT_NOT_FOUND });
                        console.warn("Index document not found");
                        reject(e);
                        return;
                    }
                    dispatch({ type: GET_INDEX_DOCUMENT_ERROR });
                    dispatch(
                        showNotificationOverflow(
                            "Errore",
                            "Si è verificato un errore durante l'aggiornamento delle informazioni",
                            "error",
                        ),
                    );
                    reject(e);
                });
        });
    };
};

export const postIndexDocument = (newIndexDocument: IndexDocument) => {
    return (dispatch: any, getState: () => RootState) => {
        dispatch(showLockOverlay(true, "Aggiornamento informazioni..."));
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: UPLOAD_INDEX_DOCUMENT_START });
            axios
                .post(
                    `${API_BE4FE_URL}/index-document?itemId=${itemId}`,
                    newIndexDocument,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch(hideLockOverlay());
                    dispatch({
                        type: UPLOAD_INDEX_DOCUMENT_SUCCESS,
                        payload: result.data,
                    });
                    // dispatch(getIndexDocument()); (DEPRECATED - now is read from upload response)
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch(hideLockOverlay());
                    dispatch({ type: UPLOAD_INDEX_DOCUMENT_ERROR });
                    dispatch(
                        showNotificationOverflow(
                            "Errore",
                            "Si è verificato un errore durante l'aggiornamento delle informazioni",
                            "error",
                        ),
                    );
                    // TODO: save somewhere the last update actions and if this fails update the
                    // local state to consider the fail (optimistic logic)
                    reject(e);
                });
        });
    };
};
